import { useMemo } from "react";
import { partGroups } from "@/engine/labels";
import { fr } from "@/i18n/fr";
import { selectStep, useViewerStore } from "@/state/store";

export function PartsChips() {
	const step = useViewerStore(selectStep);
	const labels = useViewerStore((s) => s.data?.labels);
	const setHovered = useViewerStore((s) => s.setHovered);
	const groups = useMemo(
		() => (step && labels ? partGroups(step, labels) : []),
		[step, labels],
	);
	if (!step) return null;
	return (
		<div className="parts">
			<h3>{fr.parts}</h3>
			<div className="chips">
				{groups.length === 0 && <span className="none">{fr.noParts}</span>}
				{groups.map((g) => (
					<button
						key={g.label + (g.code ?? "")}
						type="button"
						className="chip"
						onPointerEnter={() => setHovered(g.names)}
						onPointerLeave={() => setHovered([])}
						onFocus={() => setHovered(g.names)}
						onBlur={() => setHovered([])}
					>
						{g.names.length > 1 && (
							<span className="qty">×{g.names.length}</span>
						)}
						{g.label}
						{g.code && <code>{g.code}</code>}
					</button>
				))}
			</div>
		</div>
	);
}
